<template>
  <div class="support-ticket-content-w">
    <div class="support-ticket-content">
      <div class="support-ticket-content-header">
        <h3 class="ticket-header">{{ current.titulo }}</h3>
        <a class="back-to-index" href="#">
          <i class="os-icon os-icon-arrow-left5"></i>
          <span>Back</span>
        </a>
        <a class="show-ticket-info" href="#">
          <span>Show Details</span>
          <i class="os-icon os-icon-documents-03"></i>
        </a>
      </div>
        <div class="ticket-content">{{ current.descripcion }}</div>

      <div class="ticket-thread">
        <div class="ticket-reply">
          <div class="ticket-reply-info">
            <a class="author with-avatar" href="#">
              <img v-if="current.usuario_asignado" alt :src="current.usuario_asignado.image" />
              <span>{{ current.usuario_asignado }}</span>
            </a>
            <span class="info-data">
              <span class="label">replied on</span>
              <span class="value">May 27th, 2017 at 7:42am</span>
            </span>
            <div class="actions" href="#">
              <i class="os-icon os-icon-ui-46"></i>
              <div class="actions-list">
                <a href="#">
                  <i class="os-icon os-icon-ui-49"></i>
                  <span>Edit</span>
                </a>
                <a href="#">
                  <i class="os-icon os-icon-ui-09"></i>
                  <span>Mark Private</span>
                </a>
                <a href="#">
                  <i class="os-icon os-icon-ui-03"></i>
                  <span>Favorite</span>
                </a>
                <a class="danger" href="#">
                  <i class="os-icon os-icon-ui-15"></i>
                  <span>Delete</span>
                </a>
              </div>
            </div>
          </div>
          <div class="ticket-reply-content">
            <p>Hi. For the featured recipe banner feature, I'm able to enable it to show selected recipe and post on the feature recipe banner.</p>
            <p>Is there any way the enable the feature banner to show recent recipe and post instead?</p>
            <p>Thank you.</p>
          </div>
          <div class="ticket-attachments">
            <a class="attachment" href="#">
              <i class="os-icon os-icon-ui-51"></i>
              <span>Bug Report.xml</span>
            </a>
            <a class="attachment" href="#">
              <i class="os-icon os-icon-documents-07"></i>
              <span>Sytem Information.txt</span>
            </a>
          </div>
        </div>
        <div class="ticket-reply highlight">
          <div class="ticket-reply-info">
            <a class="author with-avatar" href="#">
              <img alt src="img/avatar3.jpg" />
              <span>Phil Collins</span>
            </a>
            <span class="info-data">
              <span class="label">replied on</span>
              <span class="value">May 12th, 2017 at 11:23am</span>
            </span>
            <span class="badge badge-success">support agent</span>
            <div class="actions" href="#">
              <i class="os-icon os-icon-ui-46"></i>
              <div class="actions-list">
                <a href="#">
                  <i class="os-icon os-icon-ui-49"></i>
                  <span>Edit</span>
                </a>
                <a href="#">
                  <i class="os-icon os-icon-ui-09"></i>
                  <span>Mark Private</span>
                </a>
                <a href="#">
                  <i class="os-icon os-icon-ui-03"></i>
                  <span>Favorite</span>
                </a>
                <a class="danger" href="#">
                  <i class="os-icon os-icon-ui-15"></i>
                  <span>Delete</span>
                </a>
              </div>
            </div>
          </div>
          <div class="ticket-reply-content">
            <p>Hi. For the featured recipe banner feature, I'm able to enable it to show selected recipe and post on the feature recipe banner.</p>
            <p>Is there any way the enable the feature banner to show recent recipe and post instead?</p>
            <p>Thank you.</p>
          </div>
        </div>
        <div class="ticket-reply">
          <div class="ticket-reply-info">
            <a class="author with-avatar" href="#">
              <img alt src="img/avatar1.jpg" />
              <span>John Mayers</span>
            </a>
            <span class="info-data">
              <span class="label">replied on</span>
              <span class="value">April 9th, 2017 at 7:41am</span>
            </span>
            <div class="actions" href="#">
              <i class="os-icon os-icon-ui-46"></i>
              <div class="actions-list">
                <a href="#">
                  <i class="os-icon os-icon-ui-49"></i>
                  <span>Edit</span>
                </a>
                <a href="#">
                  <i class="os-icon os-icon-ui-09"></i>
                  <span>Mark Private</span>
                </a>
                <a href="#">
                  <i class="os-icon os-icon-ui-03"></i>
                  <span>Favorite</span>
                </a>
                <a class="danger" href="#">
                  <i class="os-icon os-icon-ui-15"></i>
                  <span>Delete</span>
                </a>
              </div>
            </div>
          </div>
          <div class="ticket-reply-content">
            <p>Hi. For the featured recipe banner feature, I'm able to enable it to show selected recipe and post on the feature recipe banner.</p>
            <p>Is there any way the enable the feature banner to show recent recipe and post instead?</p>
            <p>Thank you.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="support-ticket-info">
      <div class="customer">
        <div class="avatar">
          <img alt :src="current.usuario_crea.image" />
        </div>
        <h4 class="customer-name">{{ current.usuario_crea.first_name }} {{ current.usuario_crea.last_name }}</h4>
        <div class="customer-tickets">Ultimo Login: <timeago :datetime="current.usuario_crea.last_login"></timeago></div>
      </div>
      <h5 class="info-header">Detalles</h5>
      <div class="info-section text-center">
        <div class="label">Creada:</div>
        <div class="value"><timeago :datetime="current.fecha_creacion"></timeago></div>
        <div class="label" v-if="current.tipo_tarea">Tipo Tarea</div>
        <div class="value" v-if="current.tipo_tarea">
          <div class="badge badge-primary">{{ current.tipo_tarea.titulo}}</div>
        </div>
        <div class="label" v-if="current.etiqueta">Etiqueta</div>
        <div class="value" v-if="current.etiqueta">
          <div class="badge badge-primary">{{ current.etiqueta.titulo}}</div>
        </div>
      </div>
      <h5 class="info-header">Usuarios Asignados</h5>
      <div class="info-section">
        <ul class="users-list as-tiles" v-if="current.usuario_asignado">
          <li>
            <a class="author with-avatar" href="#">
              <div class="avatar" :style="{ 'background-image': 'url(' + current.usuario_asignado.image + ')' }"></div>
              <span>{{ current.usuario_asignado.first_name }} {{ current.usuario_asignado.last_name }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
import TareasService from "@/services/tareas/TareasService";
export default {
  components: {},
  props: {
    current: {
      type: Object
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>